interface LinhaInova {
  id: number;
  informeInovaNao: number | string | null;
}

export function idsTerceirosSelecionados(
  dados: LinhaInova[],
  idsSelecionados: number[]
): number[] {
  const idsTerceiros = new Set(
    dados
      .filter((linha) => Number(linha.informeInovaNao) === 1)
      .map((linha) => linha.id)
  );

  return Array.from(new Set(idsSelecionados)).filter((id) =>
    idsTerceiros.has(id)
  );
}
